import React from "react";
import { ShareNetwork, LinkedinLogo, TwitterLogo } from "@phosphor-icons/react";

const OG_TITLE = "ClickForge Lead Agent — Real Midwest leads + AI outreach";
const OG_DESCRIPTION =
  "OpenStreetMap discovery, Hunter enrichment, Claude audits, and Stripe checkout — all in one lightweight CRM.";
const OG_URL_LABEL = "clickforgeds.com";

export default function OgPreviewCard() {
  const imgSrc = "/og-image.png";
  return (
    <div className="bg-zinc-900/60 border border-zinc-800 rounded-sm p-5 lg:col-span-2" data-testid="og-preview-card">
      <div className="flex items-center gap-2 mb-4">
        <ShareNetwork size={16} weight="duotone" className="text-orange-500" />
        <div className="font-display font-medium text-zinc-100">Social share preview</div>
      </div>

      <p className="text-xs text-zinc-500 mb-4">
        This is how your landing page renders when someone drops your URL into LinkedIn, Slack, or Twitter/X.
      </p>

      <div className="grid md:grid-cols-2 gap-4">
        {/* LinkedIn / Facebook / Slack style */}
        <div data-testid="og-preview-linkedin">
          <div className="flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-wider text-zinc-500 mb-2">
            <LinkedinLogo size={12} weight="fill" /> LinkedIn · Slack · Facebook
          </div>
          <div className="bg-zinc-950 border border-zinc-700/60 rounded-sm overflow-hidden">
            <img
              src={imgSrc}
              alt="OG preview"
              data-testid="og-preview-linkedin-image"
              className="w-full h-auto block"
              style={{ aspectRatio: "1200/630" }}
            />
            <div className="px-3 py-2.5 bg-zinc-900/80 border-t border-zinc-800">
              <div className="text-[10px] uppercase font-mono text-zinc-500 truncate">{OG_URL_LABEL}</div>
              <div className="text-sm text-zinc-100 font-medium leading-snug mt-0.5 line-clamp-2">{OG_TITLE}</div>
              <div className="text-xs text-zinc-500 leading-relaxed mt-1 line-clamp-2">{OG_DESCRIPTION}</div>
            </div>
          </div>
        </div>

        {/* Twitter / X card */}
        <div data-testid="og-preview-twitter">
          <div className="flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-wider text-zinc-500 mb-2">
            <TwitterLogo size={12} weight="fill" /> Twitter / X
          </div>
          <div className="bg-zinc-950 border border-zinc-700/60 rounded-2xl overflow-hidden">
            <img
              src={imgSrc}
              alt="OG preview"
              data-testid="og-preview-twitter-image"
              className="w-full h-auto block"
              style={{ aspectRatio: "1200/630" }}
            />
            <div className="px-3 py-2 border-t border-zinc-800">
              <div className="text-sm text-zinc-100 font-medium leading-snug line-clamp-1">{OG_TITLE}</div>
              <div className="text-[11px] text-zinc-500 mt-0.5">{OG_URL_LABEL}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4 text-[11px] font-mono text-zinc-600 leading-relaxed">
        Preview mirrors the tags in <span className="text-zinc-400">frontend/public/index.html</span>. To regenerate the
        image, edit the copy in <span className="text-zinc-400">backend/scripts/generate_og_image.py</span> and run
        <span className="text-orange-400"> python3 backend/scripts/generate_og_image.py</span>.
      </div>
    </div>
  );
}
